import { ReactElement } from 'react';

import { useFormField } from '@components/form';
import { FormError } from '@components/form-error';
import { FormLabel } from '@components/form-label';
import { IconProps } from '@components/icons';
import { Stack } from '@components/stack';
import { TextEditor } from '@components/text-editor';

import { TextEditorToolbar } from 'components/TextEditorToolbar';

type Props = {
  description?: string;
  id: string;
  label: string;
  labelIcon?: ReactElement<IconProps>;
  placeholder?: string;
};

export const JobDescriptionEditor = ({
  description = '',
  id,
  label,
  labelIcon,
  placeholder,
}: Props) => {
  const jobDescriptionProps = useFormField({
    id: id,
    label: label,
    defaultValue: description,
    validators: ['required'],
    valueType: 'text-editor',
  });
  return (
    <Stack space={1}>
      <FormLabel text={jobDescriptionProps.label} icon={labelIcon} />
      <TextEditor
        error={Boolean(jobDescriptionProps.error)}
        initialEditorState={description}
        onChangeHtml={jobDescriptionProps.onChange}
        variant="gray"
      >
        <TextEditorToolbar />
        <TextEditor.Input placeholder={placeholder} />
      </TextEditor>
      {jobDescriptionProps.error !== 'error' && <FormError text={jobDescriptionProps.error} />}
    </Stack>
  );
};
